<template>
    <b-calendar
        v-show="show"
        v-model="value"        
        selected-variant="info"
        today-variant="primary"
        nav-button-variant="info"
        class="calendar-overlay"
        :min="min" 
        :max="max"
        :hide-header="true"
        :date-info-fn="dateClass"
        :date-disabled-fn="dateDisabled"
        :locale="this.local"
        @input="onDateSelected"
        @context="onContextChanged"        
    />    
</template>

<script>
    export default {
        name: 'DatePickerPage',        
        props: {
            show: Boolean,
            availableDates: Array,
            mindate: String,
            enddate: String,
            focusDate: String            
        },
        data() {            
            return {                
                value: null,
                min: this.mindate,
                max: this.enddate,                
                currentMonth: 0,
                local: 'it',
                selectedDate: 0,
                warnignCoeff: 0.7,
                datesLoaded: false
            };
        },

        mounted() {
            const Language = this.$route.query.lang
            if (Language) {
                this.local = Language.toLowerCase() 
            }
        },

        watch: {
            availableDates: {
                immediate: true,
                handler(newVal) {
                    if (newVal.length > 0) {
                        this.datesLoaded = true;
                    }
                }
            },
            focusDate: {
                immediate: true,
                handler(newVal) {
                    this.value = newVal;
                }
            }
        },
        
        methods: {
            filteredAvaibleDate(oneDate) {                
                
                if (this.datesLoaded) {                    
                    return this.availableDates[0].timeSlots.filter(timeSlot => { 
                        const slotDate = new Date(timeSlot.startDate).toISOString().slice(0, 10);
                        return slotDate === oneDate;
                    });
                }
                return []

            },


            filteredCapacity(dataTimeSlots) {
                const validTimeSlots = dataTimeSlots.filter(timeSlot => timeSlot.capacity !== -1);
                if (validTimeSlots) {
                    const capacity = validTimeSlots.reduce((sum, timeSlot) => sum + timeSlot.capacity, 0) || -1;
                    const occupancy = validTimeSlots.reduce((sum, timeSlot) => sum + timeSlot.occupiedCapacity, 0);                
                    return {capacity, occupancy};
                };                
            },

            async onDateSelected(date) {               

                await new Promise(resolve => {
                    const checkLoaded = () => {
                        if (this.datesLoaded) {
                            resolve();
                        } else {
                            setTimeout(checkLoaded, 100); 
                        }
                    };

                    checkLoaded(); 
                });

                const filteredTimeSlots = this.filteredAvaibleDate(date)
                
                if (filteredTimeSlots.length > 0) {                    

                    const dataCap = this.filteredCapacity(filteredTimeSlots);
                    
                    if (dataCap.capacity == -1 || dataCap.capacity > dataCap.occupancy) {                        
                        this.$emit('dateSelected', date);
                        this.$emit('closeCalendar');
                    }

                }                

            },
            onContextChanged(ctx) {               
                
                if (ctx.activeDate) {
                    this.selectedDate = ctx.activeDate.getDate();
                    this.currentMonth = ctx.activeDate.getMonth();                    
                }
            },
            dateClass(ymd, date) {                

                const filteredTimeSlots = this.filteredAvaibleDate(ymd)
                
                if (filteredTimeSlots.length > 0) {

                    const dataCap = this.filteredCapacity(filteredTimeSlots)
                    
                    if (dataCap.capacity === -1) {
                        return 'table-success';
                    } else if (dataCap.capacity <= dataCap.occupancy) {
                        return 'table-danger';
                    } else if (dataCap.occupancy >= this.warnignCoeff * dataCap.capacity) {
                        return 'table-warning ';
                    } else {
                        return 'table-success';
                    }
                }
            },
            
            dateDisabled(ymd, date) {
                const month = date.getMonth()
                const filteredTimeSlots = this.filteredAvaibleDate(ymd)

                if (month !== this.currentMonth || (!filteredTimeSlots.length > 0)) {
                    return true
                }
                
            } 
        },
    };
</script>
<style scoped>
    .calendar-overlay {
        position: absolute;
        top: 6vh;
        left: 0;        
        z-index: 9999;
        background: white;        
    }
</style>